// assets
import { IconBook, IconFilePlus, IconBookmarks, IconBookmarkEdit} from '@tabler/icons-react';
import LogoIcon from '../assets/images/logos/Marabes-Logo.png';

// constant
const icons = {
  IconBook,
  IconFilePlus,
  IconBookmarks, 
  IconBookmarkEdit
};
const ImageIcon = () => (
  <img src={LogoIcon} alt="Logo" style={{ width: 30, height: 25 }} />
);

const userRole = localStorage.getItem('userRole');

// ==============================|| OFFICE POLICIES MENU ITEMS ||============================== //


const policies = {
  id: 'policies',
  title: 'Policies',
  type: 'group',
  children: [
     {
      id: 'about',
      title: 'About Marabes',
      type: 'item',
      url: '/about',
      icon: ImageIcon,
      breadcrumbs: false
    },
    {
      id: 'policies-management',
      title: 'Overview',
      type: 'item',
      url: '/policies',
      icon: icons.IconBook,
      breadcrumbs: false
    }
    
  ]
};

if (userRole === 'MANAGER' || userRole === 'HR'|| userRole === 'DIRECTOR') {
  policies.children.push(
    
  );
}
  if (userRole === 'EMPLOYEE') {
  policies.children.push(
    // {
    //   id: 'office-policies',
    //   title: 'Office policies',
    //   type: 'item',
    //   url: '/office-policies',
    //   icon: icons.IconBook,
    //   breadcrumbs: false
    // }
    
  );


}


export default policies;
